/**
 * Created by laugh on 9/21/2017.
 */

export default function (state = "no configuration", action) {

    switch (action.type) {
        case 'SET_CONFIG':
            return action.configResponse
        default:
            return state
    }

}


// WEBPACK FOOTER //
// ./src/reducers/cms-configuration.js